module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('h1', {
    staticClass: "block_1",
    attrs: {
      "id": "toc_id_4"
    }
  }, [_vm._v("Acknowledgement")]), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("Many thanks to:")]), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("Angeline, you said, “Your father was right, you are good.”")]), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("Sun, you said, “Mom, you have to do it.”")]), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("Abigail, you said, “If you can’t, God can.”")]), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("Kiki, my editor, thanks for the corrections.")]), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("Leo, thanks for getting me to protect my work.")]), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("Farai, you are worth a hundred elephants.")]), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("Thank you all for your encouragement and support.")]), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("Austin Macauley Publishers, you are the dream.")]), _vm._v(" "), _c('p', {
    staticClass: "block_3",
    attrs: {
      "id": "calibre_pb_3"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2baadc4c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index_split_003.vue
// module id = 72
// module chunks = 0